export default "__VITE_ASSET__B3Z4YRDB__"